import Cookie from "js-cookie";
import {
    AGENT_ID_COOKIE_NAME,
    SESSION_ID_COOKIE_NAME,
    SESSION_KEY_COOKIE_NAME,
    SHARED_USER_ID_COOKIE_NAME,
    PARENT_DOMAIN
} from "common/constants/Constants";
import appConfig from "utils/appConfig";

const Personalization = {
    removeSessionId(): void {
        Cookie.remove(SESSION_ID_COOKIE_NAME, { domain: PARENT_DOMAIN });
        Cookie.remove(SESSION_KEY_COOKIE_NAME, { domain: PARENT_DOMAIN });
    },

    merge(): void {
        const agentId: string = Cookie.get(AGENT_ID_COOKIE_NAME) || "";
        const sessionId: string = Cookie.get(SESSION_ID_COOKIE_NAME) || "";
        const sessionKey: string = Cookie.get(SESSION_KEY_COOKIE_NAME) || "";
        const userId: string = Cookie.get(SHARED_USER_ID_COOKIE_NAME) || "";
        const trackingUrl = `${ appConfig().personalizationBaseUrl }/psz/pixel.gif?interactionType=merge&agent_id=${ agentId }&session_id=${ sessionId }&session_key=${ sessionKey }&breg=${ userId }&referrer=${ document.referrer.replace("&", "---") }`;

        this._sendTrackingCall(trackingUrl);
    },

    _sendTrackingCall(url: string): void {
        document.createElement("img").setAttribute("src", url);
    }
};

export default Personalization;
